import styled from 'styled-components';

export const ContactSection = styled.section`
  width: 100vw;
  min-height: 100vh;
  padding: 100px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to bottom right, #f3f2ff, #fafaff);
  font-family: Raleway;
`;

export const Container = styled.div`
  text-align: center;
  width: 100%;
 
  margin: 0 auto;
  padding: 5.76vw 0.552vw;
  box-sizing: border-box;
  font-family: Raleway;

  /* Responsive comme le navbar */
  @media (max-width: 1200px) {
    width: 94vw;
  }

  @media (max-width: 768px) {
    width: 96vw;
    padding: 0 2vw;
  }

  @media (max-width: 480px) {
    width: 98vw;
    padding: 0 1vw;
  }

  @media (min-width: 2000px) {
    width: 85vw;
    max-width: 1800px;
  }
`;

export const Title = styled.h2`
  font-size: 2.6rem;
  color: #0f172a;
  font-weight: 200;
  margin-bottom: 10px;
  font-family: Raleway;
  padding: 0 5.448vw; /* Padding interne du HeaderContainer */

  @media (max-width: 768px) {
    padding: 0 4vw;
  }

  @media (max-width: 576px) {
    font-size: 2rem;
    padding: 0 3vw;
  }
`;

export const Subtitle = styled.p`
  color: #7b7b7b;
  font-size: 14px;
  max-width: 600px;
  margin: 0 auto 60px;
  line-height: 1.6;
  font-family: Raleway;
  padding: 0 5.448vw; /* Padding interne du HeaderContainer */

  @media (max-width: 768px) {
    padding: 0 4vw;
  }

  @media (max-width: 480px) {
    padding: 0 3vw;
  }
`;

export const ContactContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 60px;
  font-family: Raleway;
  padding: 0 5.448vw; /* Padding interne du HeaderContainer */

  @media (max-width: 992px) {
    flex-direction: column;
    align-items: center;
    padding: 0 4vw;
  }

  @media (max-width: 768px) {
    padding: 0 4vw;
  }

  @media (max-width: 480px) {
    padding: 0 3vw;
  }
`;

// Styles du formulaire
export const ContactForm = styled.form`
  width: 45%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: Raleway;

  @media (max-width: 992px) {
    width: 100%;
  }
`;

export const FormGroup = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const FormLabel = styled.label`
  position: absolute;
  top: ${props => props.focused ? '-8px' : '18px'};
  left: ${props => props.focused ? '12px' : '18px'};
  font-size: ${props => props.focused ? '12px' : '15px'};
  color: ${props => props.focused ? '#0f172a' : '#7b7b7b'};
  background: ${props => props.focused ? '#ffffff' : 'transparent'};
  padding: ${props => props.focused ? '0 8px' : '0'};
  transition: all 0.3s ease;
  pointer-events: none;
  z-index: 2;
  font-weight: ${props => props.focused ? '200' : '200'};
  font-family: Raleway;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 18px;
  border: none;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  font-size: 15px;
  color: #333;
  outline: none;
  font-family: Raleway;
  position: relative;
  z-index: 1;

  &:focus {
    box-shadow: 0 2px 15px rgba(15, 23, 42, 0.1);
  }
`;

export const FormTextarea = styled.textarea`
  width: 100%;
  padding: 18px;
  border: none;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  font-size: 15px;
  color: #333;
  outline: none;
  resize: none;
  font-family: Raleway;
  min-height: 150px;
  position: relative;
  z-index: 1;

  &:focus {
    box-shadow: 0 2px 15px rgba(15, 23, 42, 0.1);
  }
`;

export const SubmitButton = styled.button`
  background: #0f172a;
  color: #fff;
  padding: 16px 32px;
  border: none;
  border-radius: 20px 0 20px 0;
  cursor: pointer;
  font-weight: 200;
  font-size: 15px;
  align-self: flex-start;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.15);
  transition: all 0.3s ease;
  font-family: Raleway;

  &:hover {
    background: #1e293b;
    transform: translateY(-3px);
  }
`;

// Styles de la carte
export const MapCard = styled.div`
  width: 50%;
  background: #ffffff;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  height: 100%;
  text-align: left;
  font-family: Raleway;

  @media (max-width: 992px) {
    width: 100%;
  }
`;

export const MapTitle = styled.h3`
  color: #0f172a;
  margin-bottom: 20px;
  font-size: 1.5rem;
  position: relative;
  font-family: Raleway;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 50px;
    height: 3px;
    background: #0f172a;
    border-radius: 2px;
  }
`;

export const MapContainer = styled.div`
  height: 400px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  position: relative;
  font-family: Raleway;

  @media (max-width: 992px) {
    margin-top: 20px;
    min-height: 300px;
  }

  @media (max-width: 576px) {
    min-height: 250px;
  }
`;

export const MapIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  filter: grayscale(10%) contrast(105%) saturate(120%);
`;

export const MapOverlay = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  background: #ffffff;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  z-index: 2;
  font-size: 0.9rem;
  color: #0f172a;
  font-weight: 200;
  font-family: Raleway;

  i {
    color: #ff7b00;
    margin-right: 8px;
  }
`;

export const MapInfo = styled.p`
  margin-top: 15px;
  color: #6b7280;
  font-size: 0.9rem;
  font-family: Raleway;

  i {
    color: #ff7b00;
    margin-right: 8px;
  }
`;